import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import {
  AppBar, Toolbar, IconButton, Typography, Menu, MenuItem, Drawer,
  List, ListItem, ListItemIcon, ListItemText, CircularProgress, Snackbar,
  Divider,
  Hidden
} from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import Logo from '../assets/images/black-logo.png';
import config from '../config';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  logo: {
    maxHeight: 40,
    verticalAlign: 'middle',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: '#fff',
    color: '#222',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  title2: {
    flexGrow: 1,
    textAlign: 'right',
  },
  logoLeft: {
    height: '100%',
    width: 'auto',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  avatar: {
    height: theme.spacing(20),
    width: theme.spacing(20),
    backgroundColor: 'inherit',
  },
  appName: {
    verticalAlign: 'middle',
    display: 'inline-block',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 700,
    padding: '2px 15px 0 15px',
    marginTop: '4px',
    color: '#555',
  },
  adminApp: {
    verticalAlign: 'middle',
    display: 'inline-block',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 700,
    padding: '2px 15px 0 15px',
    marginTop: '4px',
    color: '#00b31f',
  },
  userName: {
    verticalAlign: 'middle',
    display: 'inline-block',
    alignItems: 'center',
    padding: '0 15px',
    marginTop: '4px',
    fontSize: '18px',
    [theme.breakpoints.down('sm')]: {
      display: 'None',
    },
  },
  userIcon: {
    fontSize: '30px',
    color: '#00b31f',
    verticalAlign: 'middle',
  },
  company: {
    fontSize: '18px',
    marginLeft: '15px',
  },
  version: {
    fontSize: '12px',
  }
}));

function Header(props) {
  let history = useHistory();
  const {user, access, isAuthenticated, company} = props;
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (!isAuthenticated) {
    return (
      <Typography className={classes.title} variant="h6" noWrap>
        <img src={Logo} alt="Logo" className={classes.logo} />
        <Typography component="span" className={classes.appName}>
          Mail App
        </Typography>
      </Typography>
    );
  }

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleClickMenu = (url) => (event) => {
    history.push(url);
  }

  const renderMenu = (
    <Drawer variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !drawerOpen && classes.drawerPaperClose),
      }}
      open={drawerOpen} onClose={toggleDrawer(false)}>
      <div
        className={classes.list}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <Icons.ChevronLeft />
          </IconButton>
        </div>
        <Divider />
        <List>
          {/*<ListItem>
            <Avatar className={classes.avatar}>
              <img src={LogoNK} alt="Logo" className={classes.logoLeft} />
            </Avatar>
          </ListItem>*/}
          <ListItem button onClick={handleClickMenu('/')}>
            <ListItemIcon><Icons.Home /></ListItemIcon>
            <ListItemText primary="Inicio" />
          </ListItem>
          <ListItem button onClick={handleClickMenu('/users')}>
            <ListItemIcon><Icons.Person /></ListItemIcon>
            <ListItemText primary="Usuarios" />
          </ListItem>
          <ListItem button onClick={handleClickMenu('/groups')}>
            <ListItemIcon><Icons.Group /></ListItemIcon>
            <ListItemText primary="Grupos" />
          </ListItem>
          <ListItem button onClick={handleClickMenu('/organizations')}>
            <ListItemIcon><Icons.Language /></ListItemIcon>
            <ListItemText primary="Dominios" />
          </ListItem>
        </List>
        <Divider />
        <List>
          {
            !!access.user &&
            <ListItem button component="a" href={config.apps.support}>
              <ListItemIcon><Icons.Help /></ListItemIcon>
              <ListItemText primary="Soporte" />
            </ListItem>
          }
        </List>
        <Divider />
        <List>
          <ListItem>
            <ListItemIcon></ListItemIcon>
            <ListItemText primary={'Versión ' + config.version} primaryTypographyProps={{className: classes.version}} />
          </ListItem>
        </List>
      </div>
    </Drawer>
  );

  return (
    <>
      <AppBar position="absolute" className={clsx(classes.appBar, drawerOpen && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, drawerOpen && classes.menuButtonHidden)}
          >
            <Icons.Menu />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            <img src={Logo} alt="Logo" className={classes.logo} />
            <Typography component="span" className={classes.appName}>
              Mail App
            </Typography>
          </Typography>
          <Typography className={classes.title2} variant="h6" noWrap>
            <IconButton
              edge="end"
              aria-label="Admin App"
              href={config.apps.admin}
              color="inherit"
            >
              <Typography component="span" className={classes.adminApp} noWrap>
                Admin App
              </Typography>
            </IconButton>
            
            <Typography className={classes.userName} component="span" noWrap>
              {user.attributes.name} {user.attributes.family_name}
            </Typography>
            <Icons.AccountCircle className={classes.userIcon} />
            <Typography className={classes.company} component="span" noWrap>
              {company}
            </Typography>
          </Typography>
        </Toolbar>
      </AppBar>
      <Hidden xsDown implementation="js">
        {renderMenu}
      </Hidden>
    </>
  );
}

export default Header;